export default {
  namespaced: true,
  state: {
    url: `/api/audiences`,
    audiences: []
  },
  getters: {
    getAudiences: state => state.audiences,
    getAudienceById: state => id =>
      state.audiences.find(audience => audience._id === id)
  },
  mutations: {
    setAudiences: (state, data) => {
      state.audiences = _.map(data, item => {
        return setTag(item);
      });
    },
    insertAudience: (state, data) => {
      state.audiences.push(setTag(data));
    },
    updateAudienceById: (state, {
      id,
      data
    }) => {
      let index = state.audiences.findIndex(audience => audience._id === id);
      state.audiences[index] = _.assign(state.audiences[index], data);
    }
  },
  actions: {
    async getAudiences({
      commit,
      state
    }) {
      try {
        let res = await axios.get(state.url);
        commit("setAudiences", res.data);
      } catch (e) {
        throw e;
      }
    },
    async getAudienceById({
      commit,
      state
    }, id) {
      try {
        let res = await axios.get(`${state.url}/${id}`);
        commit("insertAudience", res.data);
      } catch (e) {
        throw e;
      }
    },
    async createAudience({
      commit,
      state
    }, setObj) {
      try {
        let res = await axios.post(state.url, setObj);
        commit("insertAudience", res.data);
      } catch (e) {
        throw e;
      }
    },
    async updateAudienceById({
      commit,
      state
    }, {
      id,
      setObj
    }) {
      try {
        await axios.put(`${state.url}/${id}`, setObj);
        commit("updateAudienceById", {
          id: id,
          data: setObj
        });
      } catch (e) {
        throw e;
      }
    }
  }
};

function setTag(item) {
  item.jsTag = `<script>
    var img = document.createElement('img');
    img.width = 1;
    img.height = 1;
    img.style = 'display:none';
    img.src = '${config.dmp_endpoint}/pixels/retargeting?tag=${item.audience_id}';
  <\/script>`
  item.imagePixel = `<img src="${config.dmp_endpoint}/pixels/retargeting?tag=${item.audience_id}" height="1" width="1" style="display:none" />`
  return item
}
